import { LoginParams, LoginResponse, RefreshParams, VerifyResponse } from '../../types/AdminTypes';
import { AxiosResponse } from 'axios';
import { getAxiosWithConfig, getAxiosWithConfigAdmin } from '../Http/HttpService';
import { createStandaloneToast } from '@chakra-ui/react';

  export const login = async (loginParams: LoginParams): Promise<AxiosResponse<LoginResponse>> => {
  try {
    const instance = getAxiosWithConfig();
    return instance.post('auth', {
      username: loginParams.username,
      password: loginParams.password,
      ttltoken: loginParams.ttltoken,
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const logout = async (token: string): Promise<AxiosResponse> => {
  try {
    const instance = getAxiosWithConfigAdmin(token);
    const instancePost = instance.post('auth/logout');
    return instancePost;
  } catch (e) {
    throw new Error(e);
  }
};

export const refresh = async (
  refreshParams: RefreshParams,
  alpdesk_token: string,
): Promise<AxiosResponse> => {
  try {
    const instance = getAxiosWithConfigAdmin(alpdesk_token);

    return instance.post('/auth/refresh', {
      alpdesk_refresh_token: refreshParams.alpdesk_refresh_token,
      ttltoken: refreshParams.ttltoken,
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const verify = async (alpdesk_token: string): Promise<AxiosResponse<VerifyResponse>> => {
  try {
    const instance = getAxiosWithConfigAdmin(alpdesk_token);
    return instance.post('auth/verify');
  } catch (e) {
    throw new Error(e);
  }
};
export const getCurrentToken = (ADMIN_DETAILS: string): string => {
  const sessionData = sessionStorage.getItem(ADMIN_DETAILS);
  if (sessionData) {
    const sessionDataAsJson = JSON.parse(sessionData);
    return sessionDataAsJson.alpdesk_token;
  } else {
    return '';
  }
};
export const handleAuthentication = async (
  ADMIN_DETAILS: string,
  handleTokenState: (token: string | null) => void,
) => {
  const sessionData = sessionStorage.getItem(ADMIN_DETAILS);
  if (!sessionData) return;
  const sessionDataAsJson = JSON.parse(sessionData);
  try {
    await verify(sessionDataAsJson.alpdesk_token);
    const refreshResponse = await refresh(
      {
        alpdesk_refresh_token: sessionDataAsJson.alpdesk_refresh_token,
        ttltoken: 10000,
      },
      sessionDataAsJson.alpdesk_token,
    );
    sessionDataAsJson.alpdesk_token = refreshResponse.data.alpdesk_token;
    sessionDataAsJson.alpdesk_refresh_token = refreshResponse.data.alpdesk_refresh_token;
    sessionStorage.setItem(ADMIN_DETAILS, JSON.stringify(sessionDataAsJson));
    handleTokenState(sessionDataAsJson?.alpdesk_token);
  } catch (e) {
    try {
      await logout(sessionDataAsJson.alpdesk_token);
    } finally {
      sessionStorage.removeItem(ADMIN_DETAILS);
      handleTokenState(null);
      const toast = createStandaloneToast();
      toast({
        position: 'top-right',
        title: 'Ihre Sitzung ist abgelaufen. Sie wurden abgemeldet.',
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
    }
  }
};
